import { AfterViewInit, Component, Input, OnInit } from '@angular/core';
import { Subject } from 'rxjs';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { SystemFlowService } from '../../../../services/configuration/system-flow.service';

@Component({
  selector: 'app-system-flow-modal',
  templateUrl: './system-flow-modal.component.html',
  styleUrls: ['./system-flow-modal.component.css', '../../../../styles/modals.css']
})
export class SystemFlowModalComponent implements OnInit, AfterViewInit {

  get formData() { return this.systemFlowForm.controls; }

  constructor(
    public bsModalRef: BsModalRef,
    private formBuilder: FormBuilder,
    private systemFlowService: SystemFlowService
  ) { }

  @Input() modalTitle: string;
  itemSaved: Subject<any> = new Subject();
  systemFlowForm: FormGroup;
  objInitialState: any;
  submitted = false;
  errorMessage = '';
  isNew: boolean;
  metaflowPools = [];

  ngOnInit() {
    delete this.objInitialState['extensionData'];
    this.isNew = this.objInitialState.name === undefined;
    this.createForm();
    if (!this.isNew) { this.getMetaflowPools(); }
  }

  ngAfterViewInit() {
    if (this.objInitialState.name) {
      this.getMetaFlow();
    }
  }

  createForm() {
    this.systemFlowForm = this.formBuilder.group({
      name: [ '', Validators.compose( [
        Validators.required,
        Validators.maxLength(100),
        Validators.pattern('^[a-zA-Z][a-zA-Z0-9_]*') ])
      ],
      content: null,
      description: ['', [Validators.maxLength(250) ]],
      isValid: false,
      flowId: 0,
      hash: null,
      type: 1,
      validationDescription: null
    });
  }

  patchSystemflowValues(flow) {
    this.systemFlowForm.patchValue({
      name: flow.name,
      description: flow.description,
      content: flow.content,
      isValid: flow.isValid,
      flowId: flow.flowId,
      hash: flow.hash,
      type: flow.type,
      validationDescription: flow.validationDescription
    });
  }

  onSave() {
    const systemFlow = this.systemFlowForm.getRawValue();
    if (this.isNew) {
      this.createSystemFlow(systemFlow);
    } else {
      this.updateSystemFlow(systemFlow);
    }
  }

  createSystemFlow(flow) {
    this.errorMessage = '';
    this.systemFlowService.createSystemFlow(flow)
      .subscribe( () => {
          this.submitted = true;
          setTimeout(() => {
            flow.justCreatedOrUpdated = true;
            this.submitted = false;
            this.itemSaved.next(flow);
            this.bsModalRef.hide();
          }, 2000);
        },
        error1 => {
          let err = error1;
          if (error1.indexOf('401') !== -1) {
            err = 'Erro: Sessão expirada.';
          }
          this.errorMessage = err;
          this.submitted = false;
        });
  }

  updateSystemFlow(flow) {
    this.errorMessage = '';
    this.systemFlowService.updateSystemFlow(flow)
      .subscribe( () => {
          flow.justCreatedOrUpdated = true;
          this.submitted = true;
          this.itemSaved.next(flow);
          setTimeout(() => { this.submitted = false; this.bsModalRef.hide(); }, 2000);
        },
        error1 => {
          let err = error1;
          if (error1.indexOf('401') !== -1) {
            err = 'Erro: Sessão expirada.';
          }
          this.errorMessage = err;
          this.submitted = false;
        });
  }

  getMetaflowPools() {
    this.errorMessage = '';
    this.systemFlowService.getMetaFlowPools(this.objInitialState)
      .subscribe( pools => {
        this.metaflowPools = pools;
      }, error1 => this.errorMessage = error1);
  }

  getMetaFlow() {
    this.errorMessage = '';
    this.systemFlowService.getSystemFlow(this.objInitialState.flowId)
      .subscribe( flow => {
        this.patchSystemflowValues(flow);
      }, error1 => { this.errorMessage = error1; });
  }

  openFlowDesignerSetup() {
    window.open('./DesignerSetup/Crivo.Workflow.EditorDeFluxos.msi', '_self');
  }

  openFlowEditor() {
    this.errorMessage = '';
    if (!this.isNew) {
      this.systemFlowService.getSystemflowDesignerLink(this.objInitialState.name)
        .subscribe( response => {
          window.open(response.linkToOpen, '_parent');
        }, error1 => { this.errorMessage = error1; });
    }
  }

  onClose() {
    const flow = { justCreatedOrUpdated: this.objInitialState.justCreatedOrUpdated };
    this.itemSaved.next(flow);
    this.bsModalRef.hide();
  }

}
